import * as Icons from "lucide-react";
import { features } from "../../mock/mock";

const WhyChooseUs = () => {
  return (
    <section className="py-20 bg-white relative overflow-hidden">
      <div className="container mx-auto px-4">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-orange-100 border border-orange-200 mb-4">
            <span className="text-xs font-semibold text-orange-700 tracking-widest uppercase">Why Choose Us</span>
          </div>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold text-stone-800 mb-4">
            The <span className="text-orange-600">Aadi Gayanam</span> Advantage
          </h2>
          <p className="text-stone-600">Six pillars that make us the most loved play school in Jaipur.</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {features.map((f, i) => {
            const IconComp = Icons[f.icon] || Icons.Sparkles;
            const gradients = [
              "from-orange-100 to-amber-100",
              "from-rose-100 to-pink-100",
              "from-teal-100 to-emerald-100",
              "from-yellow-100 to-orange-100",
              "from-lime-100 to-green-100",
              "from-red-100 to-rose-100"
            ];
            const iconColors = [
              "bg-orange-500",
              "bg-rose-500",
              "bg-teal-500",
              "bg-yellow-500",
              "bg-lime-600",
              "bg-red-500"
            ];
            return (
              <div
                key={i}
                className={`group bg-gradient-to-br ${gradients[i % 6]} rounded-3xl p-8 hover:shadow-xl transition-all duration-300 hover:-translate-y-1 border border-white`}
              >
                <div className={`w-14 h-14 rounded-2xl ${iconColors[i % 6]} flex items-center justify-center mb-5 shadow-lg group-hover:scale-110 transition-transform`}>
                  <IconComp className="w-7 h-7 text-white" />
                </div>
                <h3 className="font-display font-bold text-xl text-stone-800 mb-2">{f.title}</h3>
                <p className="text-sm text-stone-600 leading-relaxed">{f.description}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
